(function($){
    // JS
    window.Recaptcha = {

        // Google Recaptcha init
        //======================================================================
        recaptcha: function()
        {
            
            if ($('#g-recaptcha').length) {        
                var verifyCallback = function(response) {
                    if (response !== '') {
                        $('.g-recaptcha-response').valid();
                    }
                };

                grecaptcha.render('g-recaptcha', {
                  'sitekey'  : SITE_KEY,
                  'callback' : verifyCallback
                });
            }

        }



    }
    // Run
    $(function(){
        Recaptcha.recaptcha();
    });


}(jQuery));